import { render, staticRenderFns } from "./ItemMenu.vue?vue&type=template&id=2c2d4430"
import script from "./ItemMenu.vue?vue&type=script&lang=js"
export * from "./ItemMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports